export const USER_SETTINGS_COMPLETED_KEY = "userSettingsCompleted";
